import script from "./BuyVIPDialogues.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyVIPDialogues.vue?vue&type=script&setup=true&lang=ts"

import "./BuyVIPDialogues.vue?vue&type=style&index=0&id=0c1570a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1570a4"]])

export default __exports__